import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "تحويل المعدل التراكمي إلى النظام التركي";
const DESCRIPTION =
  "اكتشف كيفية تحويل معدلك الجامعي إلى النظام التركي بسهولة ودقة. اعرف تفاصيل النظام التركي للدرجات الجامعية.";
const KEYWORDS =
  "النظام الجامعي التركي, تحويل المعدل الجامعي, نظام الدرجات التركي, معدل البكالوريوس, معدل الماجستير, المعدل الجامعي, تركيا";
const OG_URL = "https://do-calculate.com/calculator/ar/gradetoturkey";
function GradeToTurkey() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToTurkishGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "AA";
    } else if (gpa >= 3.5 && gpa < 4.0) {
      return "BA";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "BB";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "CB";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "CC";
    } else if (gpa >= 1.5 && gpa < 2.0) {
      return "DC";
    } else if (gpa >= 1.0 && gpa < 1.5) {
      return "DD";
    } else if (gpa >= 0.5 && gpa < 1.0) {
      return "FD";
    } else if (gpa >= 0.0 && gpa < 0.5) {
      return "FF";
    } else {
      return "مدخلات غير صالحة";
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 25).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToTurkishGrade(gpa);
      }
    }
    return "مدخلات غير صالحة";
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  اكتشف كيفية تحويل معدلك الجامعي (مئوي أو تراكمي) إلى النظام
                  التركي بسهولة ودقة. اعرف تفاصيل النظام التركي للدرجات الجامعية
                  باستخدام هذه الأداة المفيدة.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    تحويل المعدل الجامعي إلى النظام التركي
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>نوع المعدل:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      مئوي (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      تراكمي (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "المعدل المئوي:"
                          : "المعدل التراكمي:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  احسب                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>النتيجة:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `المعدل المئوي بالنسبة للنظام التركي: ${convertedValue}`
                        : `الدرجة التركية بالنسبة للمعدل التراكمي: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      نظام تصنيف الدرجات الجامعية في تركيا
                    </h2>
                  </u>
                  <p>
                    في تركيا، يتم تصنيف الدرجات على مقياس من AA إلى FF، حيث AA
                    هو الأفضل وFF هو الأسوأ. يمكن تقسيم الدرجات على النحو
                    التالي:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>المعدل التراكمي (على مقياس 4 نقاط)</th>
                        <th>الدرجة التركية</th>
                        <th>النسبة المئوية المكافئة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>4.0</td>
                        <td>AA</td>
                        <td>90-100%</td>
                      </tr>
                      <tr>
                        <td>3.5 - 3.9</td>
                        <td>BA</td>
                        <td>85-89%</td>
                      </tr>
                      <tr>
                        <td>3.0 - 3.4</td>
                        <td>BB</td>
                        <td>80-84%</td>
                      </tr>
                      <tr>
                        <td>2.5 - 2.9</td>
                        <td>CB</td>
                        <td>75-79%</td>
                      </tr>
                      <tr>
                        <td>2.0 - 2.4</td>
                        <td>CC</td>
                        <td>70-74%</td>
                      </tr>
                      <tr>
                        <td>1.5 - 1.9</td>
                        <td>DC</td>
                        <td>65-69%</td>
                      </tr>
                      <tr>
                        <td>1.0 - 1.4</td>
                        <td>DD</td>
                        <td>60-64%</td>
                      </tr>
                      <tr>
                        <td>0.5 - 0.9</td>
                        <td>FD</td>
                        <td>55-59%</td>
                      </tr>
                      <tr>
                        <td>0.0 - 0.4</td>
                        <td>FF</td>
                        <td>0-54%</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    هذه المعلومات تساعد في فهم كيفية تحويل المعدلات إلى النظام
                    التركي ومعرفة ما يعادلها بالنسبة المئوية.
                  </p>
                  <b className="text-primary">
                    <span>مثال: </span>
                    إذا كان لديك معدل تراكمي 3.0 على مقياس 4.0، يمكنك تحويله إلى
                    النظام التركي باستخدام الأداة أعلاه وستحصل على النتيجة
                    المعادلة.
                  </b>
                  <p>
                    هذه الأداة مفيدة جدًا للطلاب الدوليين الذين يرغبون في متابعة
                    دراستهم في تركيا أو التقديم على وظائف تطلب معدل دراسي معين.
                  </p>
                  <div>
                    <p>
                      تعد تركيا من الدول التي تشهد تطورًا علميًا مستمرًا، وفيها
                      العديد من الجامعات العريقة التي يقصدها الطلاب من جميع
                      أنحاء العالم.
                    </p>
                    <p className="alert alert-info">
                      أن في تركيا العديد من الجامعات المصنفة عالميًا، ويمتاز
                      النظام الدراسي في الجامعات التركية بالصرامة العلمية والجدة
                      في المناهج. وتعد التكاليف الدراسية في تركيا معقولة مقارنة
                      ببقية الدول الأوروبية والولايات المتحدة الأميركية.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeToTurkey;
